import { useAppSelector } from 'store/index';

export const useReviewsActive = () => {
    return useAppSelector(({ review }) => review.modalOpen);
};

export const useReviewsMessage = () => {
    return useAppSelector(({ review }) => review.message);
};
